import React from 'react';
import "./../css/Nav.css"
import logo from "./../img/Nav/logo.png"
import { Link } from 'react-router-dom';

function Nav() {

    let links = [
        {
            name: "Inicio",
            link: "/",
            color: "#e73a93"
        },
        {
            name: "Menú",
            link: "/menu",
            color: "#e2137d"
        },
/*         {
            name: "Galería",
            link: "/galeria",
            color: "#ca116f"
        }, */
        {
            name: "Sucursales",
            link: "/sucursales",
            color: "#b10e60"
        },
    ]
  return (
    <header className='header'>
        <div className='header__logo'>
            <img className='header__logo__img' src={logo} />
        </div>
        <div className='header__nav'>
            {
                links.map((li, index)=>
                <Link to={li.link} className='header__nav__link' color ={li.color}  style={{ backgroundColor: li.color }} key={index}>
                        {li.name}
                </Link>
                )
            }
        </div>

    </header>
  );
}

export default Nav;